import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const gbMenus = (logoUrl) => {
    const basePath = getDomainConfig(getLocale('en-GB').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: logoUrl,
                alt: 'Raisin',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Get started',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '457a0585-4847-4c2c-bbad-620101e0623c',
                            type: 'text',
                            title: 'How Raisin UK works',
                            href: `${basePath}/how-raisin-uk-works/`,
                        },
                        {
                            id: '9a91930e-db2a-45be-8eab-30b192e40e03',
                            type: 'text',
                            title: 'Quick start',
                            href: `${basePath}/guides/quick-start/`,
                        },
                    ],
                },
            },
            {
                id: '36e9994f-8c35-4d1c-a470-fab6ad144699',
                title: 'Savings accounts',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '4a17825e-a704-457c-945f-f1b45c50b29e',
                            type: 'advanced',
                            title: 'Fixed rate bonds',
                            href: `${basePath}/savings-accounts/fixed-rate-bonds/`,
                            description: 'Enjoy a competitive, fixed rate of interest over a term length of your choice',
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                        {
                            id: '8ec5d1d0-2452-4cad-acce-f8875f8b8277',
                            type: 'advanced',
                            title: 'Easy access savings',
                            href: `${basePath}/savings-accounts/easy-access-accounts/`,
                            description: 'An easy access savings account lets you top up and withdraw your cash at your convenience',
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                        {
                            id: '023386ad-c47a-44cd-be66-4ea80d25ca22',
                            type: 'advanced',
                            title: 'Notice accounts',
                            href: `${basePath}/savings-accounts/notice-accounts/`,
                            description: 'Receive a variable rate of interest and give notice when you want to withdraw your savings',
                            icon: 'terminationPaymentIcon',
                            iconColor: '#317EA6',
                        },
                    ],
                    bottom: [
                        {
                            id: 'efe277ff-d6e0-451a-8130-dbc8278f4862',
                            type: 'arrow',
                            title: 'Under 1 year fixed rate bonds',
                            href: `${basePath}/savings-accounts/fixed-rate-bonds/up-to-12-months/`,
                        },
                        {
                            id: 'c9b48d1c-e9bb-435f-951e-0f02d46ab21f',
                            type: 'arrow',
                            title: '1 year fixed rate bonds',
                            href: `${basePath}/savings-accounts/fixed-rate-bonds/1-year/`,
                        },
                        {
                            id: '85f37705-e429-45ac-87f4-d99344561b38',
                            type: 'arrow',
                            title: '2 year fixed rate bonds',
                            href: `${basePath}/savings-accounts/fixed-rate-bonds/2-year/`,
                        },
                        {
                            id: 'c9b48d2d-f0cc-535f-951e-0f02d46ab21f',
                            type: 'arrow',
                            title: '3 year fixed rate bonds',
                            href: `${basePath}/savings-accounts/fixed-rate-bonds/3-year/`,
                        },
                        {
                            id: '86e38805-e430-45bd-87f5-d99344561b38',
                            type: 'arrow',
                            title: '5 year fixed rate bonds',
                            href: `${basePath}/savings-accounts/fixed-rate-bonds/5-year/`,
                        },
                        {
                            id: '85f37805-e429-45bc-87f4-d00344561b38',
                            type: 'arrow',
                            title: 'Exclusive offers',
                            href: `${basePath}/savings-accounts/raisin-exclusive/`,
                        },
                    ],
                },
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'Help & Guides',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'savings-finance',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt68453dc5db1e4d3a/FAQs.svg',
                            iconColor: '#0E6CC5',
                            title: 'FAQs',
                            href: 'https://help.raisin.co.uk/hc/en-us',
                        },
                        {
                            id: 'investments-finance',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltc5ba40b6cbd767f5/Using_Raisin_UK.svg',
                            iconColor: '#0E6CC5',
                            title: 'Using Raisin UK',
                            href: `${basePath}/guides/`,
                        },
                        {
                            id: 'pension-finance',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt66cab0f0096dc752/Deposit_Protection.svg',
                            iconColor: '#0E6CC5',
                            title: 'Deposit protection',
                            href: `${basePath}/deposit-protection/`,
                        },
                        {
                            id: 'saving-guides',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt33bcb9b7e9a3becc/Savings_guides.svg',
                            iconColor: '#0E6CC5',
                            title: 'Savings guides',
                            href: `${basePath}/savings/`,
                        },
                        {
                            id: 'bankding-guide',
                            type: 'advanced',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt330aeed4f1b92062/Banking_guides.svg',
                            iconColor: '#0E6CC5',
                            title: 'Banking guides',
                            href: `${basePath}/banking/`,
                        },
                    ],
                },
            },
            {
                id: 'b1ef9202-f58c-4f98-a3fe-b4178a842ecb',
                title: 'About',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'c3f65470-a71c-4079-adae-a644c03c00a2',
                            type: 'text',
                            title: 'About us',
                            href: `${basePath}/about-us/`,
                        },
                        {
                            id: 'a9cbf2ad-81bc-4f83-8196-b67b414f9b0f',
                            type: 'text',
                            title: 'Contact us',
                            href: `${basePath}/contact/`,
                        },
                        {
                            id: '457a0585-4847-4c2c-bbad-620101e9512b',
                            type: 'text',
                            title: 'Our partner banks',
                            href: `${basePath}/bank/`,
                        },
                        {
                            id: '9a91930e-db2a-45be-8eab-30a081e40e03',
                            type: 'text',
                            title: 'Newsroom',
                            href: `${basePath}/newsroom/`,
                        },
                    ],
                },
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Log in',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Register',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=gbMenus.js.map